// TODO: delete this file if we don't want to handle product exports as a fall back this way
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { DefaultNotificationService } from './default-notification-service';

const messages = defineMessages({
  errorTitle: {
    description: 'productExport.errorNotificationTitle',
    defaultMessage: 'Product Export Error',
    id: 'WHbza4',
  },
  errorContent: {
    description: 'productExport.errorNotificationContent',
    defaultMessage: 'There was an error trying to export the product(s). Please try again.',
    id: 'g67W3J',
  },
});

class ProductExportNotificationServiceClass {
  get pusherMessageKey() {
    return 'Product Export';
  }

  validateMessage(message) {
    if (!message?.Notification?.Title) {
      return false;
    }

    return message.Notification.Title.includes(this.pusherMessageKey);
  }

  processMessage(message) {
    if (!message) {
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.errorTitle} />,
        content: <FormattedMessage {...messages.errorContent} />,
        notificationType: NOTIFICATION_TYPE_ERROR,
        dontHide: true,
      });
    }

    DefaultNotificationService.displayNotification(message.Notification);
  }
}

export const ProductExportNotificationService = new ProductExportNotificationServiceClass();
